<script>
  import { viewLogDetails, showViewLogModal, user } from "../../../stores";
  import { apiMethods } from "../../../Services/index.svelte";
  import { showError } from "../../../Utils/utilFunctions.svelte";
  import NotificationModal from "../NotificationModal.svelte";
  import { LogTypes } from "../../../Utils/utilEnums.svelte";
  import Loader from "../Loader.svelte";
  import ActivityLogInfo from "./ActivityLogInfo.svelte";
  import LogRequest from "./LogRequest.svelte";
  import LogResponse from "./LogResponse.svelte";
  import EclipseLogInfo from "./EclipseLogInfo.svelte";
  import EclipseLogException from "./EclipseLogException.svelte";
  import ExceptionInfo from "./ExceptionInfo.svelte";
  import ExceptionData from "./ExceptionData.svelte";
  import ActivityLogChanges from "./ActivityLogChanges.svelte";
  import UnauthorisedLogInfo from "./UnauthorisedLogInfo.svelte";
  import UnauthorisedReason from "./UnauthorisedReason.svelte";

  let previousKeyDown = null,
    isLoading = false,
    logDetails = {};

  $: if ($showViewLogModal) {
    init();
  }

  $: isUserEnableSeeRequest = $user.role >= 20;

  const init = async () => {
    isLoading = true;
    await apiMethods.getMethod
      .getLogWithTypeByID($viewLogDetails.type, $viewLogDetails.id)
      .then((res) => {
        logDetails = res;
      })
      .catch((err) => {
        showError(err);
      });
    isLoading = false;
  };

  const closeModal = () => {
    $showViewLogModal = false;
    logDetails = {};
    if ($viewLogDetails.closeFunction) $viewLogDetails.closeFunction();
    document.onkeydown = previousKeyDown ?? null;
  };
</script>

<NotificationModal
  isModalOpen={$showViewLogModal}
  confirmAction={closeModal}
  closeModalFunction={closeModal}
  showCancelBtn={false}
  submitText="Close"
  noContentPadding
  title="View {$viewLogDetails.type} Log"
  modalMaxWidth="max-w-full"
>
  <div class="flex flex-col overflow-y-auto relative p-6 gap-y-6">
    {#if isLoading}
      <Loader manualClass="mx-auto my-8" size="36px" />
    {:else if $viewLogDetails.type === LogTypes.Activity}
      <ActivityLogInfo {logDetails} />

      <ActivityLogChanges data={logDetails} />

      {#if isUserEnableSeeRequest}
        <LogRequest request={logDetails.request} />
      {/if}

      <LogResponse response={logDetails.response} />
    {:else if $viewLogDetails.type === LogTypes.Eclipse}
      <EclipseLogInfo {logDetails} on:closeModal={closeModal} />

      {#if isUserEnableSeeRequest}
        <LogRequest request={logDetails.request} />
      {/if}

      <LogResponse response={logDetails.response} />

      <EclipseLogException exception={logDetails.exception} />
    {:else if $viewLogDetails.type === LogTypes.Unauthorised}
      <UnauthorisedLogInfo {logDetails} />

      <LogRequest request={logDetails.request} />

      <UnauthorisedReason reason={logDetails.reason} />
    {:else if $viewLogDetails.type === LogTypes.Exception}
      <ExceptionInfo {logDetails} />

      <LogResponse title="Content" response={logDetails.content} />

      <ExceptionData data={logDetails.exceptionData} />
    {/if}
  </div>
</NotificationModal>
